module.exports = __webpack_public_path__ + "static/media/velour1C.35f3cefe.jpg";